<template>
    <v-container>
        <v-row text-center wrap>
            <v-col xs="12">
                <v-card>
                    <v-toolbar flat class="grey lighten-4">
                        <v-toolbar-title>Новости</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                            @click="createNewsPopup"
                            color="success"
                        >
                            Добавить
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <v-data-table
                            :headers="search.headers"
                            :items="search.data"
                            :loading="search.loading"
                            disable-pagination
                            hide-default-footer
                        >
                            <template v-slot:item="{ item }">
                                <tr>
                                    <td class="text-left">{{ item.id }}</td>
                                    <td class="text-left">{{ item.title }}</td>
                                    <td class="text-left">{{ $moment(item.created * 1000).format('YYYY-MM-DD HH:mm') }}</td>
                                    <td class="text-left">
                                        <div class="d-inline-flex align-center">
                                            <v-icon
                                                small
                                                class="mr-2"
                                                @click="updateNewsPopup(item)"
                                            >
                                                mdi-pencil
                                            </v-icon>
                                            <v-icon
                                                small
                                                @click="removeNewsPopup(item)"
                                            >
                                                mdi-delete
                                            </v-icon>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-dialog
            v-if="create.show"
            v-model="create.show"
            max-width="800"
        >
            <v-card>
                <v-card-title class="headline">Новая новость</v-card-title>
                <v-form
                    @submit.prevent="createNews"
                    autocomplete="off"
                >
                    <v-card-text>
                        <v-text-field
                            v-model="create.data.title"
                            :error-messages="create.errors.title"
                            name="title"
                            label="Заголовок"
                            type="text"
                        />
                        <label>Содержание</label>
                        <ckeditor
                            v-model="create.data.content"
                            :editor="ckeditor.editor"
                            :config="ckeditor.config"
                            height="300px"
                        />
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer/>
                        <v-btn
                            @click="create.show = false"
                            :disabled="create.progress"
                            text
                            color="error"
                        >
                            Отменить
                        </v-btn>
                        <v-btn
                            :loading="create.progress"
                            type="submit"
                            color="primary"
                        >
                            Сохранить
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
        <v-dialog
            v-if="remove.show"
            v-model="remove.show"
            max-width="600"
        >
            <v-card>
                <v-card-title class="headline">Удалить новость {{ remove.data.title }}?</v-card-title>
                <v-card-text>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="remove.show = false"
                        :disabled="remove.progress"
                        color="red darken-1"
                        text
                    >
                        Отменить
                    </v-btn>
                    <v-btn
                        @click="removeNews"
                        :loading="remove.progress"
                        color="green darken-1"
                        text
                    >
                        Удалить
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            v-if="update.show"
            v-model="update.show"
            max-width="500"
        >
            <v-card>
                <v-card-title class="headline">Редактирование новости</v-card-title>
                <v-form
                    @submit.prevent="updateNews"
                    autocomplete="off"
                >
                    <v-card-text>
                        <v-text-field
                            v-model="update.data.title"
                            :error-messages="update.errors.title"
                            name="title"
                            label="Заголовок"
                            type="text"
                        />
                        <label>Содержание</label>
                        <ckeditor
                            v-model="update.data.content"
                            :editor="ckeditor.editor"
                            :config="ckeditor.config"
                            height="300px"
                        />
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            @click="update.show = false"
                            :disabled="update.progress"
                            text
                            color="error"
                        >
                            Отменить
                        </v-btn>
                        <v-btn
                            :loading="update.progress"
                            type="submit"
                            color="primary"
                        >
                            Сохранить
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import CKEditor from '@ckeditor/ckeditor5-vue2'

import InlineEditor from '@ckeditor/ckeditor5-editor-inline/src/inlineeditor';
import EssentialsPlugin from '@ckeditor/ckeditor5-essentials/src/essentials';
import BoldPlugin from '@ckeditor/ckeditor5-basic-styles/src/bold';
import HeadingPlugin from '@ckeditor/ckeditor5-heading/src/heading';
import ItalicPlugin from '@ckeditor/ckeditor5-basic-styles/src/italic';
import FontPlugin from '@ckeditor/ckeditor5-font/src/font';
import LinkPlugin from '@ckeditor/ckeditor5-link/src/link';
import ParagraphPlugin from '@ckeditor/ckeditor5-paragraph/src/paragraph';

export default {
    name: "NewsController",
    components: { ckeditor: CKEditor.component },
    data () {
        return {
            ckeditor: {
                editor: InlineEditor,
                config: {
                    height: 400,
                    language: 'ru',
                    plugins: [
                        EssentialsPlugin,
                        BoldPlugin,
                        FontPlugin,
                        ItalicPlugin,
                        LinkPlugin,
                        ParagraphPlugin,
                        HeadingPlugin,
                    ],
                    fontSize: {
                        options: [
                            9,
                            10,
                            11,
                            13,
                            'default',
                            15,
                            16,
                            17,
                            18,
                            19,
                            20,
                        ],
                    },
                    toolbar: {
                        items: [
                            'heading',
                            'bold',
                            'italic',
                            'fontFamily',
                            'fontSize',
                            'fontColor',
                            'fontBackgroundColor',
                            'link',
                            'undo',
                            'redo',
                        ]
                    }
                },
            },
            create: {
                data: {
                    title: '',
                    content: '',
                },
                errors: {
                    title: [],
                    content: [],
                },
                progress: false,
                show: false,
            },
            remove: {
                data: {
                    id: '',
                    name: '',
                },
                progress: false,
                show: false,
            },
            search: {
                data: [],
                headers: [
                    {
                        text: 'ID',
                        value: 'id',
                    },
                    {
                        text: 'Заголовок',
                        value: 'title',
                    },
                    {
                        text: 'Дата публикации',
                        value: 'created',
                    },
                    {
                        text: 'Действия',
                        value: 'id',
                    },
                ],
                loading: true,
            },
            update: {
                data: {
                    id: 0,
                    title: '',
                    content: '',
                },
                errors: {
                    id: [],
                    title: [],
                    content: [],
                },
                progress: false,
                show: false,
            },
        }
    },
    computed: {
        client_id () {
            return process.env.VUE_APP_API_CLIENT_ID
        },
    },
    created () {
        this.searchNews()
    },
    methods: {
        createNews () {
            this.create.progress = true

            this.create.errors.title = []
            this.create.errors.content = []

            this.$axios.post('/manager/news/create', this.create.data)
                .then((res) => {
                    if (res.data.success) {
                        this.create.show = false
                        this.create.data.title = ''
                        this.create.data.content = ''
                    } else {
                        this.create.errors.title = res.data.errors.title || []
                        this.create.errors.content = res.data.errors.content || []
                    }

                    this.create.progress = false

                    this.searchNews()
                })
                .catch(() => {
                    this.create.progress = false
                })
        },

        createNewsPopup () {
            this.create.show = true
        },

        removeNews () {
            this.remove.progress = true

            this.$axios.post('/manager/news/remove', this.remove.data)
                .then((res) => {
                    if (res.data.success) {
                        this.remove.show = false
                        this.remove.data.id = 0
                        this.remove.data.name = ''

                        this.searchNews()
                    }

                    this.remove.progress = false
                })
                .catch(() => {
                    this.remove.progress = false
                })
        },

        removeNewsPopup (news) {
            this.remove.data.id = news.id
            this.remove.data.title = news.title
            this.remove.show = true
        },

        searchNews () {
            this.search.loading = true

            this.$axios.post('/manager/news/search')
                .then(res => {
                    if (res.data.success) {
                        this.search.data = res.data.data
                    }

                    this.search.loading = false
                })
                .catch(() => {
                    this.search.loading = false
                })
        },

        updateNews () {
            this.update.progress = true

            this.update.errors.id = []
            this.update.errors.title = []
            this.update.errors.content = []

            this.$axios.post('/manager/news/update', this.update.data)
                .then((res) => {
                    if (res.data.success) {
                        this.update.show = false
                        this.update.data.id = 0
                        this.update.data.title = ''
                        this.update.data.content = ''
                    } else {
                        this.update.errors.id = res.data.errors.id || []
                        this.update.errors.title = res.data.errors.title || []
                        this.update.errors.content = res.data.errors.content || []
                    }

                    this.update.progress = false

                    this.searchNews()
                })
                .catch(() => {
                    this.update.progress = false
                })
        },

        updateNewsPopup (news) {
            this.update.data.id = news.id
            this.update.data.title = news.title
            this.update.data.content = news.content
            this.update.show = true
        },
    },
}
</script>

<style scoped lang="scss">
.ck-editor__editable {
    min-height: 300px;
}
</style>
